/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Media_Change1Inputs */

const vi_cmspost_media_change1 = /** @type {(inputs: Cmspost_Media_Change1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi ảnh`)
};

/**

* @param {Cmspost_Media_Change1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_media_change1 = /** @type {((inputs?: Cmspost_Media_Change1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Media_Change1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_media_change1(inputs)
});
export { cmspost_media_change1 as "cmsPost_media_change" }